import { render } from "./EmptyState.vue?vue&type=template&id=5fdf67ba"
const script = {}
script.render = render

export default script